<template>
  <div class="h-100"  v-click-outside="unselectTag">
    <component v-if="selectedModalComponent != null" :is="selectedModalComponent" @close="closeModal"></component>
    <template v-if="openlearnAboutPanel">
      <learn-about @close="closeLearnAboutPanel"></learn-about>
    </template>
    <div class="d-flex" ref="fadeWhenModelOpen">
    <div class="search-bar-comm-style pt-2 col-md-6" style="display: flex;">
      <input
            type="text"
            class="rounded text-light search-bar"
            :placeholder="$t('Search tag')"
            autocomplete="off" v-model="search" @input="displayFilteredTags(false)"/>
      </div>
      <div class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
        <button class="learn-about-text-styles" @click="openLearnAboutPanel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
          </svg>{{$t('Learn about tags')}}</button>
        <button class="btn btn-outline-danger mr-2" style="border: 1px solid #831515;"  v-on:click="deleteTag()">{{$t('Delete')}}</button>
        <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;" v-on:click.stop.prevent="editTag()">{{$t('Edit')}}</button>
        <button class="btn btn-outline-primary m-2"  v-on:click.prevent="openAddTagModal">{{$t('Add')}}</button>
      </div>
      </div>
    
    <div class="col-md-12 height-set-for-component" ref="fadeWhenModelOpen" style="width:100%;">
      <ul class="tags-display-ul p-0 active-tag" v-if="tagsList.length">
        <li id="tag_field" class='view-tags' v-for="tag in tagsList" :key="tag._id" @dblclick="editTagNameField(tag._id, tag.name)">
          <div class="w-100">
              <div class="d-inline-flex">
                <span v-show="!isEditting(tag._id)"
                :class="{activeclass: activeTag === tag._id}"
                @click="selectTag(tag._id,tag.name)"
                >{{
                  tag.name
                }}</span>
                <!-- <div class="display-edit-delete-tags">
                <edit-icon
                  @click.native="editTagNameField(tag._id, tag.name)"
                  v-show="!isEditting(tag._id)"
                  class="editIcon show-tags-delete"
                ></edit-icon>
                <div class="dropdown-item show-tags-delete" v-show="!isEditting(tag._id)" @click="removeTagFromAsset(tag._id, tag.name)" >
                  <svg width="15" height="15" viewBox="0 0 16 16" class="bi bi-trash-fill"
                    style="margin-inline-end: 8px"
                    fill="#c5c0c0"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                  </svg>
                </div>
                </div> -->
              </div>
              <input
                minlength="3"
                :ref="tag._id"
                type="text"
                v-model="editedTagName"
                v-show="isEditting(tag._id)"
                @keyup.enter="updateSeletedTag(tag._id)"
                class="bg-transparent border-style rounded text-light w-100 pl-2"
                required
              />
          </div>
          <div v-show="isEditting(tag._id)">
              <div class="d-flex">
                <save-icon
                  @click.native="updateSeletedTag(tag._id)"
                ></save-icon>
                <cancel-icon @click.native="cancelTagEditField()" :tagId="tag._id"></cancel-icon>
              </div>
          </div>
        </li>
      </ul>
      <div style="font-size: 20px; margin-top: 8%; color: #686868;" v-else-if="tagsList.length==0 && search.length">{{$t('No results found for searched keyword')}}</div>
      <div style="font-size: 20px; margin-top: 8%; color: #686868;" v-else-if="tagsList.length==0">{{$t('No data found')}}</div>
    </div>
    <div>
      <pagination
        v-model="page"
        :records="totalTags"
        :per-page="perPage"
        @paginate="paginate"
        :first = "Prev"
        :last = "Next"
        :options="options"
      />
    </div>
    <add-tag
      v-show="isAddTagModalVisible"
      @close="closeAddTagModal"
    >
    </add-tag>
    <edit-tag v-show="isEditTag" v-bind="tagDetails" @close="closeEditTagModal" ></edit-tag>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import Pagination from "vue-pagination-2";
import AddTag from "../tags/AddTag.vue"
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import EditTag from "./editTag.vue";
import Multiselect from 'vue-multiselect';
import LearnAbout from "./LearnAboutTags.vue";
import {NotifierConstants} from "../../components.constants.js";

 
export default {
  name:'MultiSelect',
  data(){
    return {
      tagsList: [],
      search: "",
      editedTagName: "",
      page: 1,
      totalPages: -1,
      totalTags: -1,
      perPage: -1,
      isAddTagModalVisible: false,
      selectedTagId:"",
      activeTag:null,
      activeTagDetails:{},
      isEditTag:false,
      options:{chunk:5},
      allOptionsList:[],
      openlearnAboutPanel:false,
      selectedModalComponent:null,
      showEditDeleteIcons:null
    };
  },
  components:{
    pagination: Pagination,
    "add-tag": AddTag,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "edit-tag":EditTag,
    "Multiselect":Multiselect,
    "learn-about":LearnAbout
  },
  computed:{
    tagDetails(){
      return {tagInfo:this.activeTagDetails}
    }
  },
  methods: {
    openLearnAboutPanel(){
      this.selectedModalComponent = "learn-about";
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
    },
    // eslint-disable-next-line no-unused-vars
    paginate(page) { 
      // this.page = page;
      this.filteredTags(true);
    },
    cancelTagEditField(){
      this.editedTagName = ""
      this.selectedTagId = null
      this.activeTag = null
      this.activeTagDetails={};
    },
    unselectTag(){
      this.activeTag = null;
      this.activeTagDetails={};
    },
    updateSeletedTag(tagId){
      if(this.selectedTagId == tagId){
        if(typeof(this.editedTagName) == "undefined" || this.editedTagName.length <= 0){
          alert("Please add a valid tag name. ")
          return
        }
        if(this.editedTagName.includes(",")){
            alert("Tag name with commma(,) is not allowed");
            return false;
        }
        let payload = {name : this.editedTagName}
        payload.params ={_id:this.selectedTagId}
        this.updateExistingTag(payload).then((data) => {
          if(data.statusCode == 200){
            if('message' in data){
              this.$toast.success(data.message)
            }
            if(Object.key(data).includes("name")){
            for (var x = 0; x < this.tagsList.length; x++) {
              if (this.tagsList[x]._id == tagId) {
                this.tagsList[x].name = data.name
                }
              }
            }
          }else{
            this.$toast.error(data.message)
          }
        });
        this.cancelTagEditField();
        this.displayFilteredTags();
      }
    },
    openAddTagModal(){
      this.isAddTagModalVisible = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    closeModal(){
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
      this.selectedModalComponent = null;
      this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
    },
    closeAddTagModal(){
      this.isAddTagModalVisible = false;
      this.search = "";
      this.filteredTags(false);
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    closeEditTagModal(){
      this.cancelTagEditField();
      this.isEditTag=false;
      this.activeTag = null
      this.displayFilteredTags();
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    setFocusToInputField(tagId){
      this.$nextTick(() => {
        const editIconRef = this.$refs[tagId];
        editIconRef[0].focus();
      });
    },
    editTagNameField(tagId, tagName) {
      this.editedTagName = tagName;
      this.selectedTagId = tagId;
      this.setFocusToInputField(tagId)
    },
    selectTag(id,name){
      this.editedTagName = "";
      this.selectedTagId = null;
      this.activeTag = id;
      this.activeTagDetails = {"name":name,"id":id};
    },
    editTag(){
      if(this.activeTagDetails.id != undefined){
        this.isEditTag = true;
        this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      }else{
        alert("Select tag to edit");
        return false;
      }
    },
    isEditting(tagId) {
      return tagId === this.selectedTagId;
    },
    deleteTag(){
      if(this.activeTagDetails.id != undefined){
        this.removeTagFromAsset(this.activeTagDetails.id,this.activeTagDetails.name)
      }else{
        alert("Select tag to delete");
        return false;
      }
    },
    removeTagFromAsset(tagId, tagName){
      let confMessage = `Are You sure you want to delete the selected '"${tagName}"' tag ?`;
      let payload = {_id:tagId}
      this.isTagAttachedToAnyAsset(payload).then((data)=>{
        if(data.statusCode==200 && data.asset_tagged){
          confMessage= ""
          alert(`Selected tag "${tagName}" is in use.\nPlease unset and proceed for delete.`);
          this.activeTagDetails={};
          this.activeTag = null;
          return;
        }
        let tagInfo = {_id:tagId}
        if(confMessage.trim().length> 0 && confirm(confMessage)){
          this.deleteExistingTag(tagInfo).then((data)=>{
            if (data.statusCode==200){
              let tIdx = this.tagsList.findIndex(v => v._id === tagId);
              if(tIdx >= 0){
                this.tagsList.splice(tIdx, 1)
              }
              this.$toast.success(data.message);
              }else{
                this.$toast.error(data.message);
              }
          });
          this.activeTagDetails={};
          this.activeTag = null;
        }
      });
    },
    displayFilteredTags(){
      let payload ={}
      if(this.search.length > 0){
        payload.params = {name:this.search};
        this.getTagsOnAutocomplete(payload).then((data) => {
          this.tagsList = data["tags"];
          this.page= 1;
          this.totalPages= -1;
          this.totalTags= -1;
          this.perPage= -1;
        });
      }else{
        this.filteredTags(false)
      }
      
    },
    add_to_taglist(tag_info){
      let tag_exists = this.tagsList.filter((tag)=>tag._id==tag_info._id)
      if (tag_exists.length ==0){
        this.tagsList.push(tag_info)
      }else{
        Object.assign(tag_exists[0], tag_info)
      }
    },
    filteredTags(isPageClick = false){
      this.$nextTick(() => {
          let payload ={}
          let paramsInfo = {}
          if(isPageClick){
            paramsInfo['page'] = this.page
          }
          // if(typeof(this.search) != "undefined" && this.search.trim().length > 0){
          //   paramsInfo["name"] = this.search.trim()
          // }
          paramsInfo["limit"] = 340
          payload = {params:paramsInfo}
          this.getAllTagsFromServer(payload).then((data) => {
            this.totalPages = data["page_count"];
            // this.page = data["page"];
            this.totalTags = data["total_tags"];
            this.perPage = data["tags_per_page"];
            this.tagsList = []
            for (const tag_info of data["tags"]) {
              this.add_to_taglist(tag_info) 
            }
          });
      });
    },
    handleTagNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let tag_info = notification.message
        if (notification.message_type == NotifierConstants.tagRemovedNotification){
          this.tagsList = this.tagsList.filter((tag)=>tag._id!=tag_info._id)
        }else{
          this.add_to_taglist(tag_info)
        }
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.tagCreatedNotification, NotifierConstants.tagModifiedNotification, NotifierConstants.tagRemovedNotification],
            callback:this.handleTagNotification,
            parent:"ShowTags"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.tagCreatedNotification, NotifierConstants.tagModifiedNotification, NotifierConstants.tagRemovedNotification],
            callback:this.handleTagNotification,
            parent:"ShowTags"})
    },
    ...mapActions("tags", ["getAllTagsFromServer", "updateExistingTag","isTagAttachedToAnyAsset","deleteExistingTag","getTagsOnAutocomplete"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created(){
    this.registerforWebsocketNotifications()
    this.filteredTags(false)
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>

<style lang="scss" scoped>
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;

.border-style{
  border: $border-color !important;
}
.activeclass{
  color:$active-blue !important;
}
.view-tags {
  font-size:12px!important;
  height: 30px!important;
  display: inline-flex!important;
  margin: 2px!important;
  border: 1px solid $tags-border-color!important;
  border-radius: 15px!important;
  min-width: 50px!important;
  padding: 0!important;
  text-align: center;
  width: auto!important;
  padding-inline-start: 1px!important;
  justify-content: center;
  padding-top: 4px!important;
  background: $tags-background-color;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size:12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}
.editIcon {
  margin-inline-start: 9px;
}

.view-tags:hover {
  border: $border-color !important;
}

.tags-display-ul{
  text-align:start;
}
.dropdown-item{
  padding:0px !important;
  width:13px !important;
}

.show-tags-delete {
  margin-inline-start: 1px;
  margin-inline-end: 5px;
}

svg{
  fill:$svg-color !important;
}

.height-set-for-component{
  height:calc(100% - 150px);
  overflow:auto;
}
.search-bar-comm-style{
  margin-top: 5px;
  .search-bar{
    background: $primary-background !important;
    height:42px;
    width: 260px !important;
    float: inline-start;
    padding: 0px 12px 0 8px;
    padding-inline-start: 12px;
    border: $border-color !important;
  }
}

.primary-btn-style{
    text-align: end;
    button{
        height: 38px;
        width: 70px;
        font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

.display-edit-delete-tags{
  display: none;
}

.view-tags:hover{
  .display-edit-delete-tags{
    display: flex;
  }
}
// //pagination
::v-deep {
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 5px;
            float:inline-end;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}

.learn-about-text-styles{
  width: 158px !important;
  color:$learn-about-text-color;
  text-align: end;
  padding-inline-end: 17px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
    fill:$learn-about-text-color !important;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
  svg{
    fill:$learn-about-text-color-hover !important;
  }
}

</style>